import ai from '@/assets/icons/file/AI.svg'
import avi from '@/assets/icons/file/AVI.svg'
import csv from '@/assets/icons/file/CSV.svg'
import doc from '@/assets/icons/file/DOC.svg'
import docx from '@/assets/icons/file/DOCX.svg'
import file from '@/assets/icons/file/FILE.svg'
import gif from '@/assets/icons/file/GIF.svg'
import jpeg from '@/assets/icons/file/JPEG.svg'
import jpg from '@/assets/icons/file/JPG.svg'
import mov from '@/assets/icons/file/MOV.svg'
import mp3 from '@/assets/icons/file/MP3.svg'
import mp4 from '@/assets/icons/file/MP4.svg'
import mpeg from '@/assets/icons/file/MPEG.svg'
import pdf from '@/assets/icons/file/PDF.svg'
import png from '@/assets/icons/file/PNG.svg'
import ppt from '@/assets/icons/file/PPT.svg'
import pptx from '@/assets/icons/file/PPTX.svg'
import psd from '@/assets/icons/file/PSD.svg'
import rar from '@/assets/icons/file/RAR.svg'
import rm from '@/assets/icons/file/RM.svg'
import svg from '@/assets/icons/file/SVG.svg'
import txt from '@/assets/icons/file/TXT.svg'
import wav from '@/assets/icons/file/WAV.svg'
import xls from '@/assets/icons/file/XLS.svg'
import xlsx from '@/assets/icons/file/XLSX.svg'
import zip from '@/assets/icons/file/ZIP.svg'
import { useMemo } from 'react'

const iconMap: Record<string, typeof ai> = {
  ai,
  avi,
  csv,
  doc,
  docx,
  file,
  gif,
  jpeg,
  jpg,
  mov,
  mp3,
  mp4,
  mpeg,
  pdf,
  png,
  ppt,
  pptx,
  psd,
  rar,
  rm,
  svg,
  txt,
  wav,
  xls,
  xlsx,
  zip,
}

type FileTypeIconProps = {
  size?: number
} & ({ type: string } | { fileName: string })

export default function FileTypeIcon({ size = 24, ...props }: FileTypeIconProps) {
  const type = useMemo(() => {
    if ('type' in props) return props.type
    const i = props.fileName.lastIndexOf('.')
    return i === -1 ? 'file' : props.fileName.slice(i + 1).toLowerCase()
  }, [props])

  const Icon = iconMap[type] ?? file
  return <Icon {...props} width={size} height={size} />
}
